export const lineHeights = {
  1: "16px",
  1.25: "20px",
  1.5: "24px",
  1.75: "28px",
  2: "32px",
  2.25: "36px",
} as const;
